import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import PropTypes from "prop-types";
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import ConfigPlanCurricular from "./planCurricularCampanaComponents/ConfigPlanCurricular";
import AgregarSedeModal from "./planCurricularCampanaComponents/AgregarSedeModal";
import CopiarPlanModal from "./planCurricularCampanaComponents/CopiarPlanModal";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import { cuadroRequerimientosEliminarPlanCurricularCampanaAPI, cuadroRequerimientosGetAllCampanasDropDownAPI, cuadroRequerimientosGetAllPlanesCurricularesDropDownAPI, cuadroRequerimientosGetDataToEditPlanCurricularCampanaAPI, cuadroRequerimientosGetListaPlanCurricularCampanaAPI, cuadroRequerimientosGetSedesNotInPlanCurricularCampanaAPI, getAllSedesAPI } from "../../../../consumers/backendApisUrls";
import Paginator from "../../../directorio/Paginator";
import FormSelect from "../../../../components/atoms/Select";
import { useHistory } from "react-router-dom";


import {
    PrimaryActionButtonForPage
} from "../../styledComponents/styledComponents";
import {onKeyPressEnter} from "../../../../helper/utils";

const Styles = styled.div`
  height: 100%;

  .header-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .btn-action {
    display: flex;
    align-items: center;
    border: none;
    border-radius: 4px;
    padding: 6px 15px;
    font-family: GothamLight;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.2s;

    &.btn-copy {
      background-color: #d8d8d8;
      color: #fff;
    }

    &.btn-add {
      background-color: #d8d8d8;
      color: #fff;
    }
    
    &.btn-add-active {
        background-color: #d8d8d8;
        color: #fff;
    }

    &:focus {
        outline: none;
    }
    
    &:hover {
        background-color: #1890ff;
    }
  }

  .btn-add-sede {
      background-color: #d8d8d8;
      color: white;
  }

  .settings-btn {
      background-color: #d8d8d8;
      color: white;
      border-radius: 4px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 36px;
      height: 34px;
      transition: background 0.2s;
      
      &:hover {
          background-color: #1890ff;
      }
  }

  .table-container {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .custom-table {
    width: 100%;
    margin-bottom: 0;
    
    thead th {
      background-color: #f1f1f1;
      color: #555;
      font-weight: 600;
      text-align: center;
      vertical-align: middle;
      border-bottom: 1px solid #dee2e6;
    }

    tbody td {
      vertical-align: middle !important;
      color: #666;
      border-bottom: 1px solid #dee2e6;
    }

    tbody tr:last-child td {
        border-bottom: none;
    }

    tbody tr:hover {
        background-color: #f8f9fa;
    }

    .col-sede {
      text-align: left;
      padding-left: 20px;
    }
    .col-plan {
      text-align: left;
      width: 25%;
    }
    .col-options {
      text-align: center;
      width: 15%;
    }
  }

  .action-icon {
    cursor: pointer;
    margin: 0 8px;
    
    &:hover {
      color: #1890ff;
    }
  }

  @media (max-width: 992px) {
    .table {
      display: block;
    }
    .egssth .description {
      border: 0 !important;
    }
  }
`;

const PlanCurricularCampana = ({ campana }) => {
    const [hideConfigPlanCurricular, setHideConfigPlanCurricular] = useState(true);
    const [searchCriteria, setSearchCriteria] = useState("");


    const [resPlanCurricularCampana, setResPlanCurricularCampana] = useState({});

    const [sedesSeleccionados, setSedesSeleccionados] = useState([]);
    const [sedesFiltradosOptions, setSedesFiltradosOptions] = useState([]);
    const [allSedesOptions, setAllSedesOptions] = useState([]);

    const [plansCurricularesSeleccionados, setPlansCurricularesSeleccionados] = useState([]);
    const [plansCurricularesFiltradosOptions, setPlansCurricularesFiltradosOptions] = useState([]);
    const [allPlansCurricularesOptions, setAllPlansCurricularesOptions] = useState([]);


    const [titleSedeModal, setTitleSedeModal] = useState('');
    const [modeSedeModal, setModeSedeModal] = useState(false);
    const [dataSedeModal, setDataSedeModal] = useState({});

    const [showSedeModal, setShowSedeModal] = useState(false);
    const [resSedesNotInCampana, setResSedesNotInCampana] = useState([]);
    const [resPlansCurriculares, setResPlansCurriculares] = useState([]);

    const [showCopiarPlanModal, setShowCopiarPlanModal] = useState(false);
    const [resCampanasDropDown, setResCampanasDropDown] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = resPlanCurricularCampana?.TotalItems ?? 0;
    const indexOfLastItem = resPlanCurricularCampana?.LastItemPage ?? 1;
    const indexOfFirstItem = resPlanCurricularCampana?.FirsItemPage ?? 1;
    const totalPages = resPlanCurricularCampana?.TotalPages ?? 1;

    const [executeManageGet] = useManageGetRequest();
    const [executeManagePostRequest] = useManagePostRequest();

    const apiAllSedes = getAllSedesAPI();
    const apiSedesNotInCampana = cuadroRequerimientosGetSedesNotInPlanCurricularCampanaAPI(campana.IdCampana);
    const apiPlansCurriculares = cuadroRequerimientosGetAllPlanesCurricularesDropDownAPI();

    const history = useHistory();

    const handleConfigPlanCurricular = () => {
        setHideConfigPlanCurricular(!hideConfigPlanCurricular);
    };

    const handleCopiarPlanModal = async () => {
        await executeManageGet(
            cuadroRequerimientosGetAllCampanasDropDownAPI(),
            async (res) => {
                const campanasDropDown = (await res.data ?? []).map(c => ({ value: c.Value, label: c.Text })).filter(c => c.value !== campana.IdCampana);
                setResCampanasDropDown(campanasDropDown);
                setShowCopiarPlanModal(!showCopiarPlanModal);
            },
            false
        );
    };

    const handleCloseCopiarModal = () => {
        setShowCopiarPlanModal(!showCopiarPlanModal);
    };

    const handleAddSedeModal = async () => {
        const responseSedesNotInCampana = executeManageGet(apiSedesNotInCampana, (res) => { }, false);
        const responsePlansCurriculares = executeManageGet(apiPlansCurriculares, (res) => { }, false);
        await Promise.all([responseSedesNotInCampana, responsePlansCurriculares]).then(async (res) => {
            const sedesNotInCampana = (await res[0]?.data ?? []).map(s => ({ value: s.Value, label: s.Text }));
            const plansCurriculares = (await res[1]?.data ?? []).map(p => ({ value: p.Value, label: p.Text }));
            setResSedesNotInCampana(sedesNotInCampana);
            setResPlansCurriculares(plansCurriculares);
            setTitleSedeModal("Agregar Sede");
            setModeSedeModal(false);
            setShowSedeModal(!showSedeModal);
        });
    };

    const handleSedeModal = () => {
        setShowSedeModal(!showSedeModal);
    };

    const refetchPlanCurricularCampana = async (IdsSedes = [], IdsPlanesCurriculares = [], Page = 1, listSedes = [], listPlansCurriculares = []) => {
        const payload = {
            IdsSedes,
            IdsPlanesCurriculares,
            IdCampana: campana.IdCampana,
            Criteria: searchCriteria,
            Page
        };
        await executeManagePostRequest(cuadroRequerimientosGetListaPlanCurricularCampanaAPI(),
            payload,
            (res) => {
                setResPlanCurricularCampana(res?.data ?? {});
                updateOptionsDeFiltros(res?.data?.ExtraData ?? {}, listSedes, listPlansCurriculares);
            }, false,
            (err) => {
                console.log("error", err);
            }, false
        );
    };

    const handleClearFilters = () => {
        setSedesFiltradosOptions([]);
        setSedesSeleccionados([]);
        setPlansCurricularesFiltradosOptions([]);
        setPlansCurricularesSeleccionados([]);
        setCurrentPage(1);
        setSearchCriteria("");
    };

    const refetchSedesAndPlansCurriculares = async () => {
        const responseSedes = executeManageGet(apiAllSedes, (res) => { }, false);
        const responsePlansCurriculares = executeManageGet(apiPlansCurriculares, (res) => { }, false);
        await Promise.all([responseSedes, responsePlansCurriculares]).then(async (res) => {
            const sedes = (await res[0]?.data ?? []);
            const plansCurriculares = (await res[1]?.data ?? []);
            setAllSedesOptions(sedes);
            setAllPlansCurricularesOptions(plansCurriculares);
            refetchData(currentPage, sedes, plansCurriculares);
        });
    };

    const updateOptionsDeFiltros = async (objectResponse, listSedes = [], listPlansCurriculares = []) => {
        const sedes = objectResponse["IdsSedes"] ?? [];
        const plansCurriculares = objectResponse["IdsPlanesCurriculares"] ?? [];
        const sedesOptions = (listSedes.length > 0 ? listSedes : allSedesOptions).filter(s => sedes.includes(s.Value));
        const plansCurricularesOptions = (listPlansCurriculares.length > 0 ? listPlansCurriculares : allPlansCurricularesOptions).filter(p => plansCurriculares.includes(p.Value));
        setSedesFiltradosOptions(sedesOptions);
        setPlansCurricularesFiltradosOptions(plansCurricularesOptions);
    };

    const refetchData = async (Page = 1, listSedes = [], listPlansCurriculares = []) => {
        const IdsSedes = sedesSeleccionados ?? [];
        const IdsPlanesCurriculares = plansCurricularesSeleccionados ?? [];
        await refetchPlanCurricularCampana(IdsSedes, IdsPlanesCurriculares, Page, listSedes, listPlansCurriculares);
    };

    const prevPage = () => {
        const nextPage = Math.max(currentPage - 1, 1);
        setCurrentPage(nextPage);
    };

    const nextPage = () => {
        const nextPage = Math.min(currentPage + 1, totalPages);
        setCurrentPage(nextPage);
    };

    const handleEditPlanCurricularCampana = async (item) => {
        const IdPlanCurricularCampana = (item?.IdPlanCurricularCampana ?? 0);
        const responseSedesNotInCampana = executeManageGet(apiAllSedes, (res) => { }, false);
        const responsePlansCurriculares = executeManageGet(apiPlansCurriculares, (res) => { }, false);
        await Promise.all([responseSedesNotInCampana, responsePlansCurriculares]).then(async (res) => {
            const sedesNotInCampana = (await res[0]?.data ?? []).map(s => ({ value: s.Value, label: s.Text }));
            const plansCurriculares = (await res[1]?.data ?? []).map(p => ({ value: p.Value, label: p.Text }));
            setResSedesNotInCampana(sedesNotInCampana);
            setResPlansCurriculares(plansCurriculares);
            setTitleSedeModal("Editar Sede");
            setModeSedeModal(true);
            await executeManageGet(
                cuadroRequerimientosGetDataToEditPlanCurricularCampanaAPI(IdPlanCurricularCampana),
                (res) => {
                    const data = res.data;
                    data["IdPlanCurricularCampana"] = IdPlanCurricularCampana;
                    setDataSedeModal(data);
                    setShowSedeModal(!showSedeModal);
                }, false
            );
        });

    };

    const handleDeletePlanCurricularCampana = async (item) => {
        const IdPlanCurricularCampana = (item?.IdPlanCurricularCampana ?? 0);
        await executeManagePostRequest(
            cuadroRequerimientosEliminarPlanCurricularCampanaAPI(IdPlanCurricularCampana),
            {},
            (res) => {
                refetchData();
            }, true,
            (err) => {
                console.log("error", err);
            }, true
        );
    };

    useEffect(() => {
        refetchSedesAndPlansCurriculares();
    }, []);

    useEffect(() => {
        handleClearFilters();
    }, [campana]);

    useEffect(() => {
        refetchData(currentPage);
    }, [currentPage, sedesSeleccionados, plansCurricularesSeleccionados]);

    const handleOnChange = (res) => {
        let data = res.target?.value;
        setSearchCriteria(data);
    };
    return (
        <Styles>

                <Wrapper>
                    <div>
                        <input
                            type="text"
                            className="generic-input-criterio-busqueda"
                            style={{"width":"380px"}}
                            placeholder={"Buscar por Sede"}
                            value={searchCriteria}
                            onChange={handleOnChange}
                            onKeyUp={(e) => onKeyPressEnter(e, refetchData)}
                        />

                            <button
                                type="button"
                                className="generic-button-buscador"
                                onClick={(e)=> {e.preventDefault();refetchData()}}
                            >
                                Buscar
                            </button>
                            <a className="clean-filters" onClick={handleClearFilters}>
                                Limpiar búsqueda
                            </a>

                    </div>

                    <div className="right-actions">
                        <PrimaryActionButtonForPage onClick={() => history.push("/cuadroRequerimientosListar")} >
                            Atrás
                        </PrimaryActionButtonForPage>

                        {(resPlanCurricularCampana?.ExtraData?.PuedeCopiar ?? false) && (
                            <PrimaryActionButtonForPage onClick={handleCopiarPlanModal}>
                                Copiar Plan
                            </PrimaryActionButtonForPage>
                        )}
                        {(resPlanCurricularCampana?.ExtraData?.PuedeCrear ?? false) && (
                            <PrimaryActionButtonForPage onClick={handleAddSedeModal} >
                                Adicionar Sede
                            </PrimaryActionButtonForPage>
                        )}

                        {(resPlanCurricularCampana?.ExtraData?.PuedeAbrirModalConfigurarPlanCurricular ?? false) && (
                            <span
                                className="d-inline-flex align-items-center justify-content-center ml-2 hand-pointer"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    minWidth: '32px',
                                    minHeight: '32px',
                                    backgroundColor: 'gray',
                                    borderRadius: '50%',
                                    flexShrink: 0
                                }}
                                onClick={handleConfigPlanCurricular}
                            >
                              <FontAwesomeIcon
                                  icon="cog"
                                  style={{
                                      color: 'white',
                                      fontSize: '18px'
                                  }}
                                  title="Configurar"
                              />
                            </span>
                        )}


                    </div>




                </Wrapper>








            <div className="table-container">
                <Table hover size="sm" className="custom-table">
                    <thead className="listar-thead">
                        <tr>
                            <th className="col-sede">
                                <FormSelect
                                    options={sedesFiltradosOptions}
                                    description={'Sede'}
                                    setSelectedOptions={setSedesSeleccionados}
                                    selectedOptions={sedesSeleccionados}
                                />
                            </th>
                            <th className="col-plan">
                                <FormSelect
                                    options={plansCurricularesFiltradosOptions}
                                    description={'Plan Curricular'}
                                    setSelectedOptions={setPlansCurricularesSeleccionados}
                                    selectedOptions={plansCurricularesSeleccionados}
                                />
                            </th>
                            <th className="col-options">
                                <div className='flex font-gothan-medium'>Acciones</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="listar-tbody">
                        {(resPlanCurricularCampana?.Items ?? []).map((item, index) => (
                            <tr key={index}>
                                <td className="col-sede">{item?.Sede ?? ''}</td>
                                <td className="col-plan">{item?.PlanesCurriculares ?? ''}</td>
                                <td className="col-options">
                                    {
                                        (item?.PuedeEditar ?? false) && (
                                            <FontAwesomeIcon icon={faEdit} className="action-icon" title="Editar" onClick={async () => await handleEditPlanCurricularCampana(item)} />
                                        )
                                    }
                                    {
                                        (item?.PuedEliminar ?? false) && (
                                            <FontAwesomeIcon icon={faTrash} className="action-icon" title="Eliminar" onClick={async () => await handleDeletePlanCurricularCampana(item)} />
                                        )
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {totalPages > 1 && (
                <Paginator totalItems={totalItems}
                    firsItemPage={indexOfFirstItem}
                    lastItemPage={indexOfLastItem}
                    totalPages={totalPages}
                    page={currentPage}
                    onLeftClic={prevPage}
                    onRightClic={nextPage} />
            )}

            {hideConfigPlanCurricular === false &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <ConfigPlanCurricular showModal={handleConfigPlanCurricular} title="Configuración del Plan Curricular" />
                </div>
            }
            {showSedeModal &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <AgregarSedeModal showModal={handleSedeModal} title={titleSedeModal} mode={modeSedeModal} data={dataSedeModal} campana={campana} listSedes={resSedesNotInCampana} listPlanes={resPlansCurriculares} refetchData={refetchData} />
                </div>
            }
            {showCopiarPlanModal &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <CopiarPlanModal showModal={handleCloseCopiarModal} title="Copiar Plan" campana={campana} listCampanas={resCampanasDropDown} refetchData={refetchData} />
                </div>
            }
        </Styles>
    );
};

PlanCurricularCampana.propTypes = {
    campana: PropTypes.object.isRequired,
};

export default PlanCurricularCampana;


const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center; /* <-- esto lo arregla */
    gap: 10px;
    margin-bottom: 10px;

    .search-and-clean-buttons {
        display: flex;
        justify-content: center;
        align-items: center;

        button {
            margin: 0px 5px;
        }
    }

    .settingsBtn {
        width: 32px;
        height: 32px;
        background: #8a8a8a;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .settingsIcon {
        width: 18px;
        height: 18px;
        fill: white;
    }
    .right-actions{
        display:flex;
        align-items:center;
        gap:8px;
    }

  
`;
